import { layoutForField, selectionModeFromField } from './selectionRules';

// The editor's Formik values for a field, built the same way when the editor
// opens and after a save: `selectionMode` and `layout` only exist in the form,
// so a reset that rebuilt the values without them showed a saved Multiple choice
// as a Dropdown select with "One" selection.
export default function fieldFormValues(field) {
  return {
    label: field.label,
    element: field.element,
    selectionMode: selectionModeFromField(field),
    layout: layoutForField(field),
    options: field.options,
    placeholder: field.placeholder,
    description: field.description ?? '',
    type: field.type,
    required: field.required,
    reference: field.reference,
    hidden: field.hidden,
    limitAllowedCountries: field.limitAllowedCountries,
    showSelectedDialCode: field.showSelectedDialCode ?? true,
    defaultValue: field.defaultValue,
    showHideLogic: field.showHideLogic,
    minValue: field.minValue,
    maxValue: field.maxValue,
    collect: field.collect ?? 'billing',
    collectShippingPhone: field.collectShippingPhone ?? false,
    limitShippingCountries: field.limitShippingCountries ?? { enabled: false, countries: [] },
    limitBillingCountries: field.limitBillingCountries ?? { enabled: false, countries: [] },
    defaultCountry: field.defaultCountry ?? '',
  };
}
